/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box } from "@nordcloud/gnui";
import { Plan } from "~/generated/graphql";
import { NameWithLink } from "~/components/Tables/cells/NameWithLink";
import { ROUTES } from "~/routing/routes";
import { NextDateCell } from "~/views/plans/PlansTable/NextDateCell";
import { PlanStateIconCell } from "~/views/plans/PlansTable/PlanStateIconCell";
import { PlansGridColumns } from "./PlansGridColumns";

type Props = {
  plan: Plan;
};

export function PlansItem({ plan }: Props) {
  return (
    <Box spacing="spacing02" boxStyle="lightGrey">
      <Row>
        <Col>
          <PlansGridColumns>
            <PlanStateIconCell
              enabled={plan.enabled}
              cronExpression={plan.scheduleCron ?? ""}
              scheduleExecutionDates={plan.scheduleExecutionDates ?? []}
            />
            <NameWithLink
              name={plan.name}
              link={ROUTES.plans.generateDetails(plan.id)}
            />
            <NextDateCell
              cronExpression={plan.scheduleCron ?? ""}
              timezone={
                (plan.scheduleTimezone &&
                  Intl.DateTimeFormat().resolvedOptions().timeZone) ??
                ""
              }
              scheduleExecutionDates={plan.scheduleExecutionDates ?? []}
              nextExecutionDates={plan.nextExecutionDates ?? []}
              scheduleOffset={plan.scheduleOffset}
            />
            <NextDateCell
              cronExpression={plan.scheduleCron ?? ""}
              timezone={plan.scheduleTimezone ?? ""}
              scheduleExecutionDates={plan.scheduleExecutionDates ?? []}
              nextExecutionDates={plan.nextExecutionDates ?? []}
              scheduleOffset={plan.scheduleOffset}
            />
          </PlansGridColumns>
        </Col>
      </Row>
    </Box>
  );
}
